import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "rotate"
const RotateIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M14.215 19.947C13.5 20.147 12.755 20.25 12 20.25S10.5 20.146 9.784 19.947L10.187 18.502C10.772 18.666 11.382 18.75 12 18.75S13.228 18.666 13.813 18.502zM14.56 4.5 11.405 7.655 10.345 6.595 11.68 5.258C10.763 5.302 9.857 5.532 9.022 5.943 7.732 6.577 6.68 7.606 6.014 8.879 5.351 10.153 5.11 11.605 5.328 13.025S6.211 15.758 7.227 16.773L7.394 16.934C7.788 17.302 8.22 17.618 8.684 17.88L7.947 19.186C7.382 18.866 6.851 18.48 6.37 18.03L6.166 17.834C4.925 16.593 4.112 14.988 3.845 13.252 3.579 11.517 3.873 9.742 4.685 8.186S6.783 5.37 8.358 4.596C9.405 4.083 10.543 3.8 11.696 3.757L10.345 2.407 11.405 1.344zM19.186 16.052C18.82 16.7 18.368 17.3 17.834 17.835S16.699 18.82 16.052 19.186L15.316 17.879C15.844 17.581 16.336 17.21 16.773 16.773S17.581 15.845 17.879 15.316zM19.947 9.784C20.146 10.5 20.25 11.244 20.25 12 20.25 12.755 20.146 13.5 19.947 14.216L18.502 13.813C18.665 13.228 18.75 12.618 18.75 12S18.665 10.772 18.502 10.187zM17.834 6.166C18.368 6.7 18.82 7.301 19.186 7.948L17.879 8.684C17.581 8.155 17.21 7.664 16.773 7.227z" />
        </svg>
      }
    </span>
  )
}
export default RotateIcon
